/* tslint:disable:variable-name adjacent-overload-signatures */
import { IUserProfile } from "src/app/_interfaces/IUserProfile";
import { JurisdictionalAgency } from "../incident/wfdssCase/jurisdictionalAgency";
import { EditorGeographicArea } from "./editorGeographicArea";
import { GeographicArea } from "./geographicArea";
import { PhoneNumber } from "./phoneNumber";
import { PhoneNumberType } from "./phoneNumberType";
import { UserGeographicAreas } from "./userGeographicAreas";
import { UserRole } from "./userRole";
import { UserSecurityInfo } from "./userSecurityInfo";
import { UserUnit } from "./userUnit";

/** endpoint-factory.service.ts
 * private updateUserFromResonse(response: Response, endpointSettings: EndpointSettings) {
 * }
 */
export class User {
  userId: number;
  username: string;
  editProfileRedirectURL: string | null;
  role: UserRole; // Update UserRole to conform to new
  /** @description This is the single geographic area found in the user profile that the user can modify. All users will have one geographic area*/
  geographicArea: GeographicArea; // for non editors
  editorGeographicAreas: EditorGeographicArea[];
  userUnits: UserUnit; // Might need to remove, unsure this concept makes sense
  jurisdictionalAgency: JurisdictionalAgency;
  unit: string; // Might need to use UserUnit for this
  userProfile: IUserProfile;
  isCertifiedApprover: boolean;
  isSupport?: boolean; // This allow system to recognize support role who can mimic to other role (role & roleType properties reflect mimiced role, defaul is support)
  lastAccessDate?: number; // API returns the date in epoch time format
  systemAccessRenewalDate: number; // epoch time

  userSecurityInfo: UserSecurityInfo; // Remove

  constructor(user?: User) {
    if (user) {
      this.userId = user.userId;
      this.username = user.username;
      this.editProfileRedirectURL = user.editProfileRedirectURL;
      this.role = user.role;
      this.geographicArea = user.geographicArea;
      this.editorGeographicAreas = user.editorGeographicAreas;
      this.userUnits = user.userUnits;            
      this.jurisdictionalAgency = !!user.jurisdictionalAgency
        ? new JurisdictionalAgency(user.jurisdictionalAgency)
        : null;
      this.unit = user.unit;      
      this.userProfile = user.userProfile;
      this.isCertifiedApprover = user.isCertifiedApprover;
      if(user.role.roleType === 'SUPPORT') this.isSupport = true;
      this.lastAccessDate = user.lastAccessDate;
      if(user.lastAccessDate) {
        this.systemAccessRenewalDate = user.lastAccessDate + (330 * 24 * 60 * 60 * 1000); // 330 days added to last access date
      }

      this.userSecurityInfo = user.userSecurityInfo;

    } else {
    }
  }
}

export class UserUtilites {
  static getUserSearchName(user: User): string {
    if (user === undefined) return null
    let searchName = '';

    if (user?.geographicArea?.abbreviation || user?.jurisdictionalAgency?.shortName) {
      searchName = user?.userProfile?.lastName + ", " + user?.userProfile?.firstName +
        ` (${user?.geographicArea?.abbreviation ?? ""}${user?.geographicArea?.abbreviation && user?.jurisdictionalAgency?.shortName ? ", " : ""}${user?.jurisdictionalAgency?.shortName ?? ""
        }) `;

    } else {
      searchName = user?.userProfile?.lastName + ", " + user?.userProfile?.firstName
    }
    return searchName
  }

  static getUserFirstNameSpaceLastName(user: User){
    return user?.userProfile?.firstName + " " + user?.userProfile?.lastName;
  }

  static getUserProfileFirstNameSpaceLastName(userProfile: IUserProfile){
    return userProfile?.firstName + " " + userProfile?.lastName;
  }
}
